export * from "./types/types";
export * from "./wrappers/wrappers";
export { KreFormIonicModule } from "./ui-ionic.module";

export { KreFormIonDialogService } from "./tools/dialog.service";

export { IonKreFormFloat } from "./kre-form.float";

export { KreFormFieldIonTagsComponent } from "./components/tags_component";
